import { NumericFormat, type SourceInfo } from 'react-number-format';
import { AMOUNT_REGEXP, cn } from '../lib';

interface AmountInputProps {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  className?: string;
  isDisabled?: boolean;
}

export const AmountInput: React.FC<AmountInputProps> = ({
  value,
  onChange,
  placeholder = '0.00',
  className,
  isDisabled,
}) => {
  const handleChange = ({ value }: { value: string }, sourceInfo: SourceInfo) => {
    // If value is changed by the prop, don't trigger onChange
    if (!sourceInfo.event) return;

    const newValue = parseFloat(value);

    if (isNaN(newValue)) {
      onChange(0);
    }
    
    if (AMOUNT_REGEXP.test(newValue.toString())) {
      onChange(newValue);
    }
  };

  return (
    <NumericFormat
      allowNegative={false}
      className={cn(
        'w-full bg-surface-00-transparent px-1 font-right-grotesk text-4xl font-black uppercase leading-9 tracking-[-0.36px] outline-none',
        className,
      )}
      placeholder={placeholder}
      value={value}
      onValueChange={handleChange}
      disabled={isDisabled}
    />
  );
};
